import { Injectable, Inject } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class RelatorioService {
  public URL = environment.angularJSconstants.URLAPICLIENTE;

  constructor(private http: HttpClient) {}

  public async consultarLinkRelatorioSla(
    ano: string,
    mes: string,
    dia: string
  ): Promise<{ url: string }> {
    const url = `${this.URL}/relatorios/sla/${ano}/${mes}/${dia}`;

    return this.http.get<{ url: string }>(url).toPromise();
  }

  public async consultarRelatorio(idCliente: number): Promise<any> {
    try {
      const url = `${this.URL}/relatorio-automatizado/${idCliente}`;

      const data = await this.http.get(url).toPromise();

      return data;
    } catch (error) {
      throw error;
    }
  }

  public async consultaClientePrincipal(idCliente: number): Promise<any> {
    try {
      const url = `${this.URL}/clientes-principal/${idCliente}`;

      const data = await this.http.get(url).toPromise();

      return data;
    } catch (error) {
      throw error;
    }
  }

  public async criarRelatorio(relatorio: any): Promise<any> {
    try {
      const url = `${this.URL}/relatorio-automatizado`;

      const data = await this.http.post(url, relatorio).toPromise();

      return data;
    } catch (error) {
      throw error;
    }
  }

  public async excluirRelatorio(id: number): Promise<any> {
    try {
      const url = `${this.URL}/relatorio-automatizado/${id}`;

      const data = await this.http.delete(url).toPromise();

      return data;
    } catch (error) {
      throw error;
    }
  }

  public async atualizarRelatorio(id: number, relatorio: any): Promise<any> {
    try {
      const url = `${this.URL}/relatorio-automatizado/${id}`;

      const data = await this.http.put(url, relatorio).toPromise();

      return data;
    } catch (error) {
      throw error;
    }
  }

  public async atualizarAgendaRelatorio(id: number, agenda: any): Promise<any> {
    try {
      const url = `${this.URL}/relatorio-automatizado/agenda/${id}`;

      const data = await this.http.put(url, agenda).toPromise();

      return data;
    } catch (error) {
      throw error;
    }
  }
}
